export default __webpack_public_path__ + "static/media/Helvetica-Bold.ed57aca7.ttf";